module.exports = __webpack_public_path__ + "img/wj.ff5e1003.png";